import { ServicePage } from "@/components/site/ServicePage";

const n = (re) => (it) => re.test(it.name_no || "");

const CONTENT = {
  no: {
    docTitle: "Bilnøkler i Stavanger – ekstranøkkel, keyless og AKL | RB TUN AS",
    desc: "Bilnøkler i Stavanger: ekstranøkkel med transponder, nøkkel med fjernkontroll, Smart Key / Keyless, Mercedes FBS3 og alle nøkler mistet. Se priser og få tilbud.",
    eyebrow: "Bilnøkler · Stavanger", h1: "Bilnøkler og programmering av bilnøkler", h1a: "Bilnøkler", h1b: "i Stavanger.",
    intro: "Vi freser, programmerer og koder nøkler til de fleste bilmerker – fra ekstranøkkel til ny nøkkel når alle nøklene er mistet. Vi hjelper bilister i Stavanger, Sandnes og hele Rogaland.",
    sections: [
      { id: "ekstranokkel", service: "bilnokkel", match: n(/ekstran/i), title: "Ekstranøkkel",
        body: "Kopi av eksisterende nøkkel med transponderbrikke – frest, programmert og klar til bruk." },
      { id: "fjernkontroll", service: "bilnokkel", match: n(/fjernkontroll/i), title: "Nøkkel med fjernkontroll",
        body: "Ny eller ekstra bilnøkkel med fjernkontroll, programmert og tilpasset bilen din." },
      { id: "smart-key", service: "bilnokkel", match: n(/smart|keyless/i), title: "Smart Key / Keyless",
        body: "Programmering av smartnøkler og keyless go for biler med nøkkelfritt system." },
      { id: "mercedes-fbs3", service: "bilnokkel", match: n(/fbs3/i), title: "Mercedes FBS3",
        body: "Nøkler til Mercedes-Benz med FBS3-startsperre – programmert og klar til bruk." },
      { id: "alle-nokler-mistet", service: "bilnokkel", match: n(/mistet|akl/i), title: "Alle nøkler mistet (AKL)",
        body: "Ny nøkkel og programmering selv om du har mistet alle nøklene til bilen." },
    ],
    other: { to: "/chiptuning", label: "Chiptuning" },
  },
  en: {
    docTitle: "Car keys in Stavanger – spare keys, keyless and AKL | RB TUN AS",
    desc: "Car keys in Stavanger: spare keys with transponder, keys with remote, Smart Key / Keyless, Mercedes FBS3 and all keys lost. See prices and get a quote.",
    eyebrow: "Car keys · Stavanger", h1a: "Car keys", h1b: "in Stavanger.",
    intro: "We cut, program and code keys for most car brands – from a spare key to a new key when all keys are lost. We help drivers in Stavanger, Sandnes and all of Rogaland.",
    sections: [
      { id: "ekstranokkel", service: "bilnokkel", title: "Spare key", body: "A copy of your existing key with transponder chip – cut, programmed and ready to use." },
      { id: "fjernkontroll", service: "bilnokkel", title: "Key with remote", body: "A new or spare car key with remote, programmed and adapted to your car." },
      { id: "smart-key", service: "bilnokkel", title: "Smart Key / Keyless", body: "Programming of smart keys and keyless go for cars with a keyless system." },
      { id: "mercedes-fbs3", service: "bilnokkel", title: "Mercedes FBS3", body: "Keys for Mercedes-Benz with the FBS3 immobiliser – programmed and ready to use." },
      { id: "alle-nokler-mistet", service: "bilnokkel", title: "All keys lost (AKL)", body: "A new key and programming, even if you have lost every key to the car." },
    ],
    other: { to: "/chiptuning", label: "Chiptuning" },
  },
};

export default function BilnoklerPage() {
  return <ServicePage content={CONTENT} path="/bilnokler" testid="bilnokler-page" />;
}
